import { transition } from '@angular/animations';
import { P } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { assetUrl } from 'src/app/globals/globals';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { ConversorService } from '../../services/api/conversor.service'

@Component({
  selector: 'app-conversor',
  templateUrl: './conversor.component.html',
  styleUrls: ['./conversor.component.scss']
})
export class ConversorComponent implements OnInit {
  assetUrl = assetUrl;

  programs : any[];
  benefits: any = [];
  types: any = [];
  selectedCurrency: string = 'millas';
  inputAmount: number = 0;
  outputAmount: number = 0;
  conversionStep: number = 0;
  ready: number = 0;
  interval: any;
  step: number = 0;
  conversorForm: FormGroup;
  errorLatam = false;
  errorConversor = false;



  constructor(
    private _conversorService : ConversorService,
    private _benefitService : BenefitsService,
    private formbuilder: FormBuilder,
    private _authService: AuthService
  ) {
    this.programs = [];

    this.conversorForm = this.formbuilder.group({
      inputValue: new FormControl('', []),
    });

  }

  ngOnInit(): void {

    this.getBenefits();
    this.getConversionTypes();
    var tthis = this;

    return this._conversorService.getAll()
    .subscribe({
      next: (response:any) => {
        tthis.ready++;
        this.programs = response.programs;
      },
      error: (err:any) => {
        tthis.ready++;
        if(err.error.Error) {
          tthis.errorLatam = true;
        }else {
          tthis.errorConversor = true;
        }
      }
    })

  }


  getBenefits() {
    var tthis = this;
    this._benefitService
      .get()
      .toPromise()
      .then((benefits: any) => {
        tthis.ready++;
        this.benefits = benefits;
      });
  }

  getConversionTypes() {
    var tthis = this;
    this._conversorService.getConversionTypes().toPromise()
    .then((type: any) => {
      tthis.ready++;
      this.types.push(type.find((el: any) => el.iD_ConversionType == 1))
      this.types.push(type.find((el: any) => el.iD_ConversionType == 2))

    })
  }

  handleCurrencyChange(event: any): any {
    this.selectedCurrency = event.target.value;
    let step = 1;

    if(this.selectedCurrency == 'puntos'){
      step = this.types[1].step;
    } else if(this.selectedCurrency == 'millas') {
      step = this.types[0].step;
    }

    this.step = step;

    this.conversorForm.get('inputValue')?.setValue('');
    this.outputAmount = 0;
  }

  puedeConvertir() {
    return parseInt(this.conversorForm.get('inputValue')?.getRawValue()) > 0;
  }

  handleInputChange(event: any): any {
    let output = 0;
    this.outputAmount = 0;
    let availableBalance;
    let step = 1;
    let ratio;

    if(this.selectedCurrency == 'millas'){
      availableBalance = this.programs[1].availableBalance;
      step = this.types[0].step;
      ratio = this.types[0].ratio;
    } else if(this.selectedCurrency == 'puntos') {
      availableBalance = this.programs[0].availableBalance;
      step = this.types[1].step;
      ratio = this.types[1].ratio;
    }

    this.step = step;

    if(!isNaN(event.target.value)) {
      this.conversorForm.get('inputValue')?.setValue(event.target.value - (event.target.value % step));
    }

    if(event.target.value.length < 1)
    {
      this.conversorForm.get('inputValue')?.setValue('');
    }

    if(event.target.value > availableBalance)
    {
      event.target.value = availableBalance
      this.conversorForm.get('inputValue')?.setValue(event.target.value);
    }else
    if(event.target.value < 0)
    {
      this.conversorForm.get('inputValue')?.setValue('');
    }
    else
    {
      let parsedEvent = parseInt(event.target.value);
      this.inputAmount = Math.round(parsedEvent);
      output = Math.round(parsedEvent * ratio);
      if(!isNaN(output))
          this.outputAmount = output;
    }
  }

  handleInputAmountChange(event: any): any {
    var tthis = this;
    clearInterval(this.interval);
    this.interval = setInterval(function(){
      tthis.handleInputChange(event);
      clearInterval(tthis.interval);
  }, 1000);


  }

  handleConversion(): any {
    this.conversionStep = 2;
    let tthis = this;
    this._conversorService.convert({
      type: tthis.selectedCurrency == 'millas' ? '1' : '2',
      quantity: tthis.inputAmount.toString()
    })
    .subscribe({
      next: (res: any) => {
        if (res.conversionStatus.id == 10)
        {
          tthis.conversionStep = 3;

          tthis.outputAmount;
          tthis.inputAmount;
          if(tthis.selectedCurrency == 'millas') {
            tthis.programs[1].availableBalance -= tthis.inputAmount;
            tthis.programs[1].balance -= tthis.inputAmount;

            tthis.programs[0].availableBalance += tthis.outputAmount;
            tthis.programs[0].balance += tthis.outputAmount;
          } else {
            tthis.programs[0].availableBalance -= tthis.inputAmount;
            tthis.programs[0].balance -= tthis.inputAmount;

            tthis.programs[1].availableBalance += tthis.outputAmount;
            tthis.programs[1].balance += tthis.outputAmount;
          }

          tthis._authService.getPerson().subscribe(data => {
            tthis._authService.refreshUser(data);

          });
        }
        else
        {
          this.conversionStep = 4;
        }
      },
      error: (err:any) => {
        this.conversionStep = 4;
      }
    })
    .catch((error: any) => {
      console.log(error)
    })
  }

}
